import { styledWrapperBase } from "@/styles/common";
import tw, { styled } from "twin.macro";

export const StyledWrapperMain = styled.main`
  ${tw`bg-neutral-99 flex flex-col w-full gap-ml relative`}
`;

export const StyledWrapperContent = styled.main`
  ${styledWrapperBase};
  ${tw`flex flex-col w-full gap-l`}
`;
